import React, { useEffect, useState } from 'react'

import { useLazyQuery } from '@apollo/client'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import widgetStyles from '../widgets.module.scss'
import { CURRENT_SERIES_LIST } from '@graphql/globalwidget/rankings.query'
import CustomLink from '@shared/components/customLink'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import Skeleton from '@shared/components/skeleton'
import WidgetCardHeader from '../widgetHeader'

function CurrentSeries({ dataSSR }) {
  const [list, setList] = useState([])
  const [getCurrentPopularSeries, { data, loading }] = useLazyQuery(CURRENT_SERIES_LIST, { context: { headers: { 'Cache-Control': 'public, max-age=300, s-maxage=600, stale-while-revalidate=420' } } })
  useEffect(() => {
    !dataSSR && getCurrentPopularSeries()
  }, [])
  useEffect(() => {
    const sourceData = dataSSR || data
    const results = sourceData?.getCurrentPopularSeries?.aResults || []
    setList(results.slice(0, 5))
  }, [dataSSR, data])

  return (
    <>
      {list?.length !== 0 &&
        <section className={widgetStyles.card}>
          <WidgetCardHeader headerText={'Current Series'} link={allRoutes.cricketSeriesNew} internalLink={true} />
          <div className={styles.list}>
            {list?.map((series) => {
              return (
                <CustomLink key={series?._id} href={`/${series?.oSeries?.oCategory?.oSeo?.sSlug || series?.oSeries?.oSeo?.sSlug}`} prefetch={false}>
                  <a className={`${styles.item} d-flex align-items-center justify-content-between`}>
                    <span className={`${styles.title} overflow-hidden text-nowrap`}>{series?.oSeries?.sTitle}</span>
                    <span className={styles.arrow}>&rsaquo;</span>
                  </a>
                </CustomLink>
              )
            })}
            {loading && (
              [0, 1, 2, 3, 4].map((i) => <div key={i} className={styles.item}> <Skeleton height={'16px'} /> </div>)
            )}
          </div>
        </section>
      }
    </>
  )
}

CurrentSeries.propTypes = {
  dataSSR: PropTypes.object
}

export default CurrentSeries
